<div class="container" *ngIf="themeService.showHeader">
  <app-menu></app-menu>
</div>
<div class="main" style="{{!themeService.showHeader ? 'padding-top: 0;' : 'padding-top: 3.5rem;'}}">
  <app-breadcrumb *ngIf="themeService.showHeader"></app-breadcrumb>
  <router-outlet></router-outlet>
  <p-toast position="top-right" key="toast_geral"></p-toast>
</div>
